import React, { Component } from "react";
import { FaRegBookmark } from "react-icons/fa";
import axios from "axios";
import { FaRegSadTear } from "react-icons/fa";
// import {Link} from "react-router-dom"
// import { PiCurrencyNgn } from "react-icons/pi";
// import NumberDisplay from "../currencyValue";


class RelatedVideo extends Component {
    state = {
        courses: [],
    }

    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        let headers = {}; // Initialize an empty headers object

        if (accessToken) {
            headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }
    
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
                headers: headers,
               
            });
            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };


    relatedcourse = () => {
        const { courses } = this.state;

        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        const CurrentCourse = courses.filter((item) => item.id === courseId);
        const RemoveCurrentCourse = courses.filter((item) => item.id !== courseId);

        const currentCourseLabels = CurrentCourse.length > 0 ? CurrentCourse[0].labels : null;

        const filteredCourses = RemoveCurrentCourse.filter((item) => {
            if (currentCourseLabels === null) {
                return false;
            }
            return item.labels === currentCourseLabels;
        })
        return filteredCourses.slice(0, 4);
    };

     slugify(text) {
        return text
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with -
          .replace(/^-+|-+$/g, '');   // trim dashes
      }

    handleRedirect = (value, name) =>{
        const accessToken = localStorage.getItem("accessToken");
        if(accessToken){
            window.location = `/description/${value}/${this.slugify(name)}`
        }else{
            window.location = `/Landing_description/${value}/${name}`
        }
    }

    render() {
        const relatedvideo = this.relatedcourse()
        const Related_course = relatedvideo.length ? relatedvideo.map((course) => {
            return (
                // <Link  to={"/description/" + course.id}>
                <div className="course_cover" onClick={() => this.handleRedirect(course.id,course.title)}>
                    <div className="image">
                        <img src={course.thumbnail} alt={"course" + course.id} />
                    </div>
                    <div className="about">
                        <h4>
                            <span>{course.labels}</span><br />
                            {course.title}
                        </h4>
                        {/* <p><PiCurrencyNgn /><NumberDisplay  value = {course.price}/> </p> */}
                        <button className="edit"><FaRegBookmark /></button>
                    </div>

                </div>
                // </Link>
            )
        }) : (
            <div className="enroll_error" >
                <div className="enroll_cover">
                    <FaRegSadTear />
                    <p>No Related Courses</p>
                </div>
            </div>
        )

        return (
            <section className="related_video">
                <h3>Related Courses </h3>
                {Related_course}
            </section>

        )
    }
}

export default RelatedVideo